export const LOCAL_STORAGE_KEYS = {
  Identifier: '_ident',
  OTP: 'PS_TPLE',
  FirebaseToken: '_fsbtk'
}

export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || ''

export const USER_ROLE = {
  STUDENT: 'Student',
  TEACHER: 'Teacher',
  GUEST: 'GUEST'
}

export const GradeMapText = (grade) => `ประถม ${grade}`

export const IMAGE_TYPE = ['image/jpeg', 'image/png', 'image/gif']

export const GRADES = [
  {
    text: 'ประถม 1',
    key: 1
  },
  {
    text: 'ประถม 2',
    key: 2
  },
  {
    text: 'ประถม 3',
    key: 3
  },
  {
    text: 'ประถม 4',
    key: 4
  },
  {
    text: 'ประถม 5',
    key: 5
  },
  {
    text: 'ประถม 6',
    key: 6
  },
  {
    text: 'มัธยม 1',
    key: 7
  },
  {
    text: 'มัธยม 2',
    key: 8
  },
  {
    text: 'มัธยม 3',
    key: 9
  }
]

export const ThaiMemberRole = {
  Owner: 'เจ้าของกลุ่ม',
  TeacherAssistant: 'ครู/อาจารย์',
  Student: 'นักเรียน'
}

export const EducationLevel = [
  {
    id: 'ElementarySchool',
    name: 'ระดับประถม'
  },
  {
    id: 'JuniorHighSchool',
    name: 'ระดับมัธยมต้น'
  }
]

export const PDF_FONT = 'THSarabun'
export const PDF_BASE_MARGIN_TOP = 35
export const PDF_BASE_MARGIN_LEFT = 30
export const PDF_TABLE_FULL_WIDTH = 530

export const PDF_THAI_COLOR_RGB = [159, 36, 237]
export const PDF_ENG_COLOR_RGB = [239, 37, 179]
export const PDF_SOC_COLOR_RGB = [47, 163, 63]
export const PDF_SCI_COLOR_RGB = [57, 25, 243]
export const PDF_MATH_COLOR_RGB = [255, 136, 37]
export const PDF_MATH2_COLOR_RGB = [255, 108, 62]

export const HEADER_COLUMN_GAP = 12
// export const PDF_THAI_COLOR_RGB = [57, 25, 243]

export const STYLE_TABLE = {
  HEAD: {
    fontStyle: 'bold',
    font: 'THSarabun',
    fontSize: 14,
    fillColor: '#eaeaea',
    textColor: 'black',
    lineColor: 'black',
    valign: 'middle'
  },
  BODY: {
    font: 'THSarabun',
    fontStyle: 'normal',
    fontSize: 14,
  },
  BODY_ALL_CORRECT: {
    font: 'THSarabun',
    fontStyle: 'normal',
    textColor: '#15cf62',
    fontSize: 14,
  },
  maxCellHeight: 4
}

export const TAB_SUBJECT = {
  primaryId: ['THAI', 'ENG', 'SCI', 'MATH', 'SOC', ''],
  hightId: ['THAI', 'ENG', 'SCI', 'SOC', 'c6e35b15-53ed-436a-941d-56072f4a2043', 'e7b12659-abc1-4658-8ac9-0650ccaf3ee6', ''],
  lastId: ['THAI', 'SCI', 'SOC', 'c6e35b15-53ed-436a-941d-56072f4a2043', 'e7b12659-abc1-4658-8ac9-0650ccaf3ee6', '']
}

export const FILTER_GRADE = {
  PAGE_NAME: {
    Subject: 'Subject',
    Bookmark: 'Bookmark',
    Free: 'Free',
    MyExam: 'MyExam',
    SuggestExam: 'SuggestExam',
    TestingHistory: 'TestingHistory',
    StatTesting: 'StatTesting',
    GroupTestingHistory: 'GroupTestingHistory',
    GroupStudentAnalysis: 'GroupStudentAnalysis'
  }
}